import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import {
  viewInfluencer,
  cancelViewInfluencer,
  requestLocationChange,
  generateInfluencerReport,
  generateCollectiveReport,
  removeInfluencer,
  removeCollective,
  getNextInfluencerPage,
  getNextCollectivePage,
  loadInitialSearchResults,
  getFilteredResults,
  requestTabChange,
  resetCollectiveReportButton,
  resetInfluencerReportButton,
  searchInfluencers,
  incrementPage,
} from '../actions';
import types from '../constants/actionTypes';
import debounce from 'lodash/debounce';
import { LIST_VIEW, GRID_VIEW, INFLUENCER_TAB, COLLECTIVE_TAB } from '../constants/viewTypes';
import { camelizeKeys } from 'humps';

import LoadingOverlay from '../components/LoadingOverlay';
import CollectiveCard from '../components/CollectiveCard';
import DeleteActionDialog from '../components/DeleteActionDialog';
import InfluencerTiles from '../components/InfluencerTiles';
import InfluencerListItem from '../components/InfluencerListItem';
import CollectiveListItem from '../components/CollectiveListItem';
import ViewToggle from '../components/ViewToggle';
import SortOrder from '../components/SortOrder';
import LoadMoreButton from '../components/LoadMoreButton';
import MergeDialog from '../components/MergeDialog';
import { InstantSearch, Index, Hits, RefinementList, Configure } from 'react-instantsearch/dom';
import { connectSearchBox, createConnector, connectHits, connectStats, connectHitsPerPage, connectStateResults } from 'react-instantsearch/connectors';
import compose from 'recompose/compose'

// Material UI Library
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import ContentFilterList from 'material-ui/svg-icons/content/filter-list';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import Badge from 'material-ui/Badge';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';

// Icons
import CommunicationEmail from 'material-ui/svg-icons/communication/email';
import ActionSearch from 'material-ui/svg-icons/action/search';

import FilterDrawer from './FilterDrawer';

import css from './search.css';
import contactsTableCss from '../components/contactsTable.css';

let checkedInfluencers = [];

const ExportListConfirmation = props => (
  <Dialog
    title="Export Search Results"
    actions={
      <div>
        <FlatButton
          label="Cancel"
          secondary={true}
          onTouchTap={props.onClose}
        />
        <FlatButton
          label="Send"
          primary={true}
          keyboardFocused={true}
          onTouchTap={props.onSend}
        />
      </div>
    }
    modal={false}
    open={props.open}
    onRequestClose={props.onClose}
  >
    <p>Sending list to: <strong>{props.email}</strong>.</p>
    <p>After clicking send It can take a few minutes to receive your export.</p>
  </Dialog>
);

const FILTER_DRAWER_BREAKPOINT = 1140;

class NewerSearch extends Component {
  state = {
    open: window.innerWidth > FILTER_DRAWER_BREAKPOINT,
    searchTerm: '',
    isViewingCard: false,
    influencerIdForDeletion: 0,
    collectiveIdForDeletion: 0,
    confirmExport: false,
    activeTab: INFLUENCER_TAB,
    checkedInfluencers: [],
    checkedCollectives: []
  }

  handleCheckInfluencer = (id, e, value) => {
    if (e.target.checked) {
      this.setState(prevState => ({ checkedInfluencers: [...prevState.checkedInfluencers, id] }))
    } else {
      this.setState(prevState => ({ checkedInfluencers: prevState.checkedInfluencers.filter(x => x !== id) }))
    }
    this.props.dispatch(resetInfluencerReportButton());
  };

  handleCheckCollective = (id, e, value) => {
    if (e.target.checked) {
      this.setState(prevState => ({ checkedCollectives: [...prevState.checkedCollectives, id] }))
    } else {
      this.setState(prevState => ({ checkedCollectives: prevState.checkedCollectives.filter(x => x !== id) }))
    }
    this.props.dispatch(resetCollectiveReportButton());
  };

  handleMenuToggle = (e) => {
    e.preventDefault();
    this.setState({ open: !this.state.open });
  }

  handleMailInfluencerResults = (searchResults, id) => {
    if(this.state.checkedInfluencers.length) {
      this.props.dispatch(
        generateInfluencerReport(
          searchResults
            .filter(hit => this.state.checkedInfluencers.indexOf(hit.objectID) !== -1)
            .map(hit => hit.objectID)
        )
      );
    } else {
      this.props.dispatch(generateInfluencerReport(searchResults.map(hit => hit.objectID)));
    }
  };

  handleMailCollectiveResults = (searchResults, id) => {
    if (this.state.checkedCollectives.length) {
      this.props.dispatch(
        generateCollectiveReport(
          searchResults
            .filter(hit => this.state.checkedCollectives.indexOf(hit.objectID) !== -1)
            .map(hit => hit.objectID)
        )
      );
    } else {
      this.props.dispatch(generateCollectiveReport(searchResults.map(hit => hit.objectID)));
    }
  };

  handleExportRequest = (callback) => {
    this.exportListCallback = callback;
    this.setState({ confirmExport: true });
  }

  handleExportCancel = () => {
    this.exportListCallback = undefined;
    this.setState({ confirmExport: false });
  };

  handleExportConfirm = () => {
    if (typeof this.exportListCallback === 'undefined' || this.exportListCallback === null) return;
    this.exportListCallback();
    this.handleExportCancel();
  }

  handleTabChange = (value) => {
    this.props.dispatch(requestTabChange(value));
  }

  searchInfluencers = (state) => {
    this.props.dispatch(searchInfluencers(state))
  }

  getNextPage = () => {
    this.props.dispatch(incrementPage(50))
  }
  

  render() {
    const badgeStyles = {
      height: '18px',
      width: '18px',
      top: '15px',
    };

    if (!this.props.currentUser.get('algoliaAppId') || !this.props.currentUser.get('algoliaSearchApiKey')) {
      return null
    }

    return (
      <div className={css.root}>
        <div className="full-height">
          <InstantSearch
            appId={this.props.currentUser.get('algoliaAppId')}
            apiKey={this.props.currentUser.get('algoliaSearchApiKey')}
            indexName="Influencer"
            style={{ width: '100%', display: 'flex' }}
          >
            <Configure hitsPerPage={this.props.hitsPerPage} />
            <div style={{ width: '100%' }}>
              <div className={css.filterControls}>
                <ConnectedSearchBox />
                {!this.state.open &&
                  <IconButton
                    onTouchTap={this.handleMenuToggle}
                  >
                    <ContentFilterList />
                  </IconButton>
                }
              </div>
              <div className="47-tab" style={{ backgroundColor: '#adadad' }}>
                <FlatButton
                  secondary={true}
                  onTouchTap={() => this.setState({ activeTab: INFLUENCER_TAB })}
                  backgroundColor="#adadad"
                  style={{ width: '50%', color: 'white', height: '100%', margin: 0, borderBottom: this.state.activeTab === INFLUENCER_TAB ? '5px solid rgb(68, 138, 255)' : '5px solid #adadad' }}
                  disabled={this.state.activeTab === INFLUENCER_TAB}
                >
                  <Badge
                    badgeStyle={badgeStyles}
                    badgeContent={<Index indexName="Influencer"><NbHits /></Index>}
                  >
                    INFLUENCERS
                 </Badge>
                </FlatButton>
                <FlatButton
                  secondary={true}
                  onTouchTap={() => this.setState({ activeTab: COLLECTIVE_TAB })}
                  backgroundColor="#adadad"
                  style={{ width: '50%', color: 'white', height: '100%', margin: 0, borderBottom: this.state.activeTab === COLLECTIVE_TAB ? '5px solid rgb(68, 138, 255)' : '5px solid #adadad' }}
                  disabled={this.state.activeTab === COLLECTIVE_TAB}
                >
                  <Badge
                    badgeStyle={badgeStyles}
                    badgeContent={<Index indexName="Collective"><NbHits /></Index>}
                  >
                    COLLECTIVES
                 </Badge>
                </FlatButton>
              </div>
              <Index indexName="Influencer">
                {this.state.activeTab === INFLUENCER_TAB &&
                  <div>
                    <HitsProp style={{ margin: '10px 20px', textAlign: 'right' }}>
                      {hits =>
                        <RaisedButton
                          label="Mail Results"
                          secondary={true}
                          labelPosition="before"
                          icon={<CommunicationEmail />}
                          disabled={this.props.influencerReportButton}
                          onTouchTap={this.handleExportRequest.bind(this, this.handleMailInfluencerResults.bind(this, hits))}
                        />
                      }
                    </HitsProp>
                    <ResultsSection
                      index="Influencer"
                      dispatch={this.props.dispatch}
                      checkedInfluencers={this.state.checkedInfluencers}
                      handleCheckInfluencer={this.handleCheckInfluencer}
                    />
                  </div>
                }
              </Index>
              <Index indexName="Collective">
                {this.state.activeTab === COLLECTIVE_TAB &&
                  <div>
                    <HitsProp style={{ margin: '10px 20px', textAlign: 'right' }}>
                      {hits =>
                        <RaisedButton
                          label="Mail Results"
                          secondary={true}
                          labelPosition="before"
                          icon={<CommunicationEmail />}
                          disabled={this.props.collectiveReportButton}
                          onTouchTap={this.handleExportRequest.bind(this, this.handleMailCollectiveResults.bind(this, hits))}
                        />
                      }
                      </HitsProp>
                      <ResultsSection
                        index="Collective"
                        dispatch={this.props.dispatch}
                        checkedCollectives={this.state.checkedCollectives}
                        handleCheckCollective={this.handleCheckCollective}
                      />
                  </div>
                }
              </Index>
              <div style={{ padding: 20, textAlign: 'center' }}>
                <ConnectedLoadMore
                  hitsPerPage={this.props.hitsPerPage}
                  loadMore={this.getNextPage}
                />
              </div>
            </div>
            <FilterDrawer
              closeDrawer={this.handleMenuToggle}
              open={this.state.open}
              breakpoint={FILTER_DRAWER_BREAKPOINT}
            />
          </InstantSearch>
        </div>
        {!!this.state.influencerIdForDeletion ?
          <DeleteActionDialog
            isOpen={!!this.state.influencerIdForDeletion}
            cancelDialog={this.cancelInfluencerDeleteWarning}
            removeRequest={this.handleRemoveInfluencer}
            name={this.state.influencerIdForDeletion ?
              `
                ${this.props.influencers.get('items')
                .get(this.state.influencerIdForDeletion.toString())
                .get('firstName')}
                 ${this.props.influencers.get('items')
                .get(this.state.influencerIdForDeletion.toString())
                .get('lastName')}
              `
              : ''
            }
          />
          :
          <div></div>
        }
        {!!this.state.collectiveIdForDeletion ?
          <DeleteActionDialog
            isOpen={!!this.state.collectiveIdForDeletion}
            cancelDialog={this.cancelCollectiveDeleteWarning}
            removeRequest={this.handleRemoveCollective}
            name={this.state.collectiveIdForDeletion ?
              `
                ${this.props.collectives.get('items').get(this.state.collectiveIdForDeletion.toString()).get('name')}
              `
              : ''
            }
          />
          :
          <div></div>
        }
        <MergeDialog
          name={this.props.mergeId ? this.props.collectives.get('items').get(this.props.mergeId.toString()).get('name') : ''}
        />
        <ExportListConfirmation
          email={this.props.currentUser.get('email')}
          open={this.state.confirmExport}
          onClose={this.handleExportCancel}
          onSend={this.handleExportConfirm}
        />
        <LoadingOverlay loading={this.props.isFetching} />
      </div>
    );
  }
}

const handleSearch = refine => (e, value) => refine(value)

const SearchBox = ({ currentRefinement, refine }) => (
  <div className={css.searchBox}>
    <TextField
      hintText="Search"
      value={currentRefinement}
      fullWidth={true}
      underlineShow={false}
      onChange={handleSearch(refine)}
      style={{ flex: 1 }}
    />
    <ActionSearch />
  </div>
)


class ResultsSection extends Component {
  state = { }

  
  handleEditInfluencer = (id, e) => {
    this.props.dispatch(requestLocationChange('editInfluencer', { id: id }));
  };

  handleViewInfluencerDetails = (id, e) => {
    this.props.dispatch(requestLocationChange('viewInfluencer', { id: id }));
  };

  openInfluencerDeleteWarning = (id) => {
    this.setState({ influencerIdForDeletion: id });
  };

  cancelCollectiveDeleteWarning = () => {
    this.setState({ collectiveIdForDeletion: 0 });
  };

  openCollectiveDeleteWarning = (id) => {
    this.setState({ collectiveIdForDeletion: id });
  };

  handleEditCollective = (id) => {
    this.props.dispatch(requestLocationChange('editCollective', { id: id }));
  };

  handleViewCollectiveDetails = (id, e) => {
    e.preventDefault();
    this.props.dispatch(requestLocationChange('viewCollective', { id: id }));
  };

  render() {
    const { index, ...props } = this.props

    return (
      <div>
        <table className={contactsTableCss.table}>
          <ConnectedHits index={index} as="tbody">
            {({ hit }) =>
            index === 'Influencer'
              ?
              <InfluencerListItem
                key={hit.objectID}
                item={hit}
                avatar
                email
                influencer={index === 'Influencer'}
                collective={index === 'Collective'}
                phone
                mobile
                editMenu
                updatedAt
                checked={this.props.checkedInfluencers.indexOf(hit.objectID) !== -1}
                openDeleteWarning={this.openInfluencerDeleteWarning}
                handlEdit={this.handleEditInfluencer}
                handleChecked={this.props.handleCheckInfluencer}
                handleViewDetails={this.handleViewInfluencerDetails}
              />
              :
              <InfluencerListItem
                key={hit.objectID}
                item={hit}
                avatar
                influencer={index === 'Influencer'}
                collective={index === 'Collective'}
                editMenu
                updatedAt
                checked={this.props.checkedCollectives.indexOf(hit.objectID) !== -1}
                openDeleteWarning={this.openCollectiveDeleteWarning}
                handlEdit={this.handleEditCollective}
                handleChecked={this.props.handleCheckCollective}
                handleViewDetails={this.handleViewCollectiveDetails}
              />
            }
          </ConnectedHits>
        </table>
      </div>
    )
  }
}


const HitsComponent = ({ hits, index, children: Children, as: As}) => {
  const camelizedHits = camelizeKeys(hits)
  return (
    <As>
      {camelizedHits.map(hit => (
        <Children hit={hit} key={hit.objectID} />
      ))}
    </As>
  )
}

const ConnectedHits = connectHits(HitsComponent)

const ConnectedResultsSection = connectStateResults(ResultsSection)

const ConnectedSearchBox = connectSearchBox(SearchBox);

const HitsProp = connectHits(({ hits, children, style, className }) =>
  <div style={style} className={className}>
    {children(hits)}
  </div>
)

const NbHitsComponent = ({ nbHits }) => {
  if (nbHits > 999) {
    return <small style={{ fontSize: '0.625em' }}>{nbHits}</small>
  }
  return <span>{nbHits}</span>
}

const ConnectedLoadMore = compose(connectStats, connectStateResults)(({ nbHits, hitsPerPage, loadMore, searching }) => {
  if (hitsPerPage > nbHits || searching) return null
  return (
    <LoadMoreButton
      loadMore={loadMore}
      disabled={false}
    />
  )
})

const NbHits = connectStats(NbHitsComponent)



function visibilityFilter(store) {
  if (!store.get('result').size) return [];

  return store.get('result').map(id =>
    store.get('items').get(`${id}`)
  ).toJS();
}

function visibilityFilterImmutable(store) {
  if (!store.get('result').size) return [];

  return store.get('result').map(id =>
    store.get('items').get(`${id}`)
  );
}

function mapStateToProps(state) {
  return {
    location: state.get('location'),
    activeFilters: state.get('activeFilters'),
    influencers: state.get('influencers'),
    searchTerm: state.get('activeFilters').get('search'),
    collectives: state.get('collectives'),
    isFetching: state.get('influencers').get('isFetching') || state.get('collectives').get('isFetching'),
    collectiveReportButton: state.get('collectives').get('collectiveReportButton'),
    influencerReportButton: state.get('influencers').get('influencerReportButton'),
    viewState: state.get('viewState').get('search'),
    hitsPerPage: state.get('viewState').get('hitsPerPage'),
    mergeId: state.get('importer').get('mergeId'),
    currentTab: state.get('viewState').get('tab'),
    currentUser: state.get('currentUser'),
  };
}

export default connect(mapStateToProps)(NewerSearch);



/** WEBPACK FOOTER **
 ** ./containers/Search.js
 **/